<template>
  <div class="page-billing-organization d-flex flex-column flex-grow-1">
    <div class="container-fluid">
      <div class="d-flex align-items-center mb-3">
        <h2 class="page-heading mr-auto">{{ headingTitle }}</h2>
        <router-link class="btn btn-link" to="/billing/organizations/search">
          К организациям
        </router-link>
      </div>
    </div>

    <subnav :heading="null" :links="tabs" :show-links="tabs.length > 0" />

    <router-view>
      <template slot-scope="{ Component }">
        <transition name="fade" mode="out-in">
          <component
            :is="Component"
            :key="$route.fullPath"
            :region="region"
            :creator="creator"
            :divisions="divisions"
            :loading="loading"
            :load-error="loadError"
          />
        </transition>
      </template>
    </router-view>
  </div>
</template>

<script>
  import api from '@/api'

  export default {
    data () {
      return {
        region: null,
        creator: null,
        divisions: [],
        loading: true,
        loadError: false,
      }
    },
    computed: {
      regionId () {
        return this.$route.params.region_id
      },
      tabs () {
        if (!this.regionId) {
          return []
        }

        const base = `/billing/organization/${this.regionId}`
        return [
          {
            text: 'Информация',
            to: `${base}/info`,
            exact: true,
          },
          {
            text: 'Графики',
            to: `${base}/charts`,
          },
        ]
      },
      headingTitle () {
        if (this.region && this.region.short_name) {
          return this.region.short_name
        }

        return 'Организация'
      },
    },
    watch: {
      regionId: {
        immediate: true,
        handler () {
          this.fetchRegion()
        },
      },
    },
    methods: {
      fetchRegion () {
        const regionId = this.regionId
        if (!regionId) {
          this.region = null
          this.creator = null
          this.divisions = []
          this.loading = false
          this.loadError = false
          return
        }

        this.loading = true
        this.loadError = false
        api.get(`billing/regions/${regionId}/details`).then(({ data }) => {
          this.region = data.region || null
          this.creator = data.creator || null
          this.divisions = data.divisions || []
          this.loadError = !this.region
        }).catch(() => {
          this.region = null
          this.creator = null
          this.divisions = []
          this.loadError = true
        }).finally(() => {
          this.loading = false
        })
      },
    },
    metaInfo () {
      if (this.region) {
        return {
          title: this.region.short_name || this.region.name || 'Организация',
        }
      }

      return {
        title: 'Организация',
      }
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/billing/organization/index.vue